import { motion } from "framer-motion";
import React, { useEffect, useState, useRef } from "react";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import { useForm } from "react-hook-form";
import styled from "styled-components";
import { yupResolver } from "@hookform/resolvers/yup";
import parse from "html-react-parser";
import * as Yup from "yup";
import {
  createChatCompletion,
  createTextToSpeechCompletion,
  getFinalPostralSummary,
  getPrescriptionHistory,
  isRxSentForAutoFillPrescription,
  meetingEndPrescriptionListFromChimeConversation,
  starpilotSingleChatStore,
  starpilotSingleChatStoreResponse,
  starpilotSingleChatStoreTextReply,
  updateAppoinmentStatus,
} from "../../../api/apiHandler";
import Swal from "sweetalert2";
import AWS from "aws-sdk";
import chatLoader from "../../../assets/chatloader.gif";

import Header from "../../../components/header/Header";
import Footer from "../../../components/footer/Footer";
import constant from "../../../constant/constant";
import constantFunc from "../../../constant/constantFunc";
// import randtoken from 'rand-token'
import AudioPlayer from "react-h5-audio-player";
import ReactAudioPlayer from "react-audio-player";
import "react-h5-audio-player/lib/styles.css";
import { v4 as uuidv4 } from "uuid";
import SpeechRecognition, {
  useSpeechRecognition,
} from "react-speech-recognition";
import queryString from "query-string";
import { Button, Col, Form, Row } from "react-bootstrap";
import pdficon from "../../../assets/pdf.png";
import txtIcon from "../../../assets/txtIcon.png";
import docIcon from "../../../assets/doc.png";
import xlsxIcon from "../../../assets/xlsx.jpg";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import talkto from "../../../assets/talkto.png";
import AutoPrescriptionPopup from "../../../components/footer/Common/AutoPrescriptionPopup";
import { useMeetingManager } from "amazon-chime-sdk-component-library-react";
import LatencyModal from "../../../components/footer/Common/LatencyPopup";
import useInaudiblePopup from "../../../hooks/useInaudiblePopup";
import { useSpeechSynthesis } from "react-speech-kit";
import TextReader from "../../../components/TextReader";
const listVariants = {
  hidden: { opacity: 0, y: 10 },
  visible: (i) => ({
    opacity: 1,
    y: 0,
    transition: { delay: i * 0.3, duration: 0.5 },
  }),
};
export default function SearchChatGpt({ drAiva = false }) {
  const [items, setItems] = useState([]);

  const userRole = localStorage.getItem("user_login_type_role");
  const role = localStorage.getItem("user_role");

  useEffect(() => {
    if (role == 4) {
      setItems([
        "StarPilot (SP) for Clergy is an Autonomous Religious, Spiritual Study and Consultation Companion.",
        "StarPilot (SP) is always listening and will respond with guidance: questions, answers, suggestions, info, references and pastoral reports.",
      ]);
    } else {
      setItems([
        "STARPILOT is an autonomous doctor/expert system. Just turn on the Status and start talking or typing.",
        "StarPilot is always listening and will respond with guidance: questions, answers, suggestions, info, references and auto prescriptions. ",
      ]);
    }
  }, [role]);

  useEffect(() => {
    const timer = setTimeout(() => {
      setItems([]); // Remove all bubbles after 1 minute
    }, 60000);

    return () => clearTimeout(timer); // Cleanup on unmount
  }, []);

  const removeBubble = (index) => {
    setItems((prevItems) => prevItems.filter((_, i) => i !== index));
  };
  const location = useParams();
  const navigate = useNavigate();
  const audioRef = useRef(null);
  const fileInputRef = useRef(null);

  // console.log("location-fgdfg->",drAiva)
  const [conversation, setConversation] = useState([]);
  const [audible, setAudible] = useState(true);
  const [storedTranscript, setStoredTranscript] = useState([]);

  const [searchValue, setSearchValue] = useState("");
  const [optionSelected, setOptionSelected] = useState(false);
  const [uuid, setUuid] = useState("");
  const [loadingChat, setLoadingChat] = useState(false);
  const [activeChat, setActiveChat] = useState(false);
  const [intervalId, setIntervalId] = useState(null);

  const [hints, setHints] = useState([]);
  const [audioStatus, setAudioStatus] = useState(true);
  const [image, setImage] = useState("");
  const [fileType, setFileType] = useState(null);
  const [uploadImage, setUploadImage] = useState(null);
  const [isNewchat, setIsNewChat] = useState(1);
  const [handleSweetAlert, setHandleSweetAlert] = useState(true);
  const [showListeningModal, setListeningModal] = useState(false);
  const [handleStartStopListening, setStartStopListening] = useState(true);
  const [instruction] = useState(constant?.auto_rx_instruction);
  const [timeoutId, setTimeoutId] = useState(null); // Store timeout ID
  const { interimTranscript, resetTranscript, transcript, listening } =
    useSpeechRecognition();
  const meetingManager = useMeetingManager();
  const validationSchema = Yup.object().shape({
    prompt: Yup.string().required("prompt is required"),
  });
  const { speak, cancel, speaking, supported, voices } = useSpeechSynthesis();
  const location2 = useLocation();
  console.log("locationworkinsss", location2.state);
  const params = queryString.parse(window.location.search);

  const formOptions = { resolver: yupResolver(validationSchema) };
  const { register, handleSubmit, formState, reset, setValue } =
    useForm(formOptions);
  const { errors } = formState;
  const [audioData, setAudioData] = useState({
    url: "",
    text: "",
    playStatus: false,
  });
  useEffect(() => {
    SpeechRecognition.startListening({ continuous: true, timeout: 5000 });
    generateUuidIfEmpty();
    // showSweetAlert()
  }, []);

  const checkNoResponse = () => {
    // Clear previous timeout if any
    if (timeoutId) clearTimeout(timeoutId);

    const id = setTimeout(() => {
      setAudible(false);
      console.log(
        "No response detected, showing 'I can't hear you...' message."
      );
      // checkNoResponse();
    }, 60000); // 1 min seconds timeout

    setTimeoutId(id);
  };
  const [speakingText, setSpeakingText] = useState(null);
  const [translatedText, setTranslatedText] = useState(null);
  const [language, setLanguage] = useState(null);
  const selectLangFunc = async (lng, type) => {
    setLanguage(lng);
  };
  const chatCreateMonteChatCompletion = () => {
    // setLoadingChat(true);
    cancel();
    starpilotSingleChatStoreResponse({
      login_type_role: localStorage.getItem("user_login_type_role"),
      uuid: location2?.state?.meeting_id ?? uuid,
      isPriestMeeting: userRole == "4" ? 1 : 0,
      languageCode: language,
    })
      .then(async (res) => {
        clearTimeout(timeoutId); // Clear timeout if response comes

        var response = JSON.parse(res);

        if (response.code == process.env.REACT_APP_SUCCESS) {
          if (response?.data) {
            console.log(response?.data, "somesta21321rpoiklot342121");

            const newMsgT = await constantFunc.convertMarkdownLinksToHTML(
              response.data.response
            );
            setLoadingChat(false);

            const chats = response.data.chatHistory;
            console.log(chats, "chats33ssssssss");

            if (userRole === "4" || params?.isPriestMeeting == "true") {
              const firstResponse = response.data.response;
              let translatedMsg = response.data.translatedMsg;

              setSpeakingText(firstResponse);
              setTranslatedText(translatedMsg);
            }
            setConversation(
              Array.isArray(chats) && chats.length > 0 ? chats : []
            );

            setAudible(true);

            checkNoResponse();
            resetTranscript();
          }
        } else {
          Swal.fire({
            position: "top-end",
            icon: "error",
            title: response.message,
            toast: true,
            showConfirmButton: false,
            timer: 2000,
          });
        }
      })
      .catch((err) => {
        console.error("API Error:", err);
        // setConversation((prev) => [
        //   "Something went wrong. Please check your internet connection.",
        //   ...prev,
        // ]);
        setLoadingChat(false);
      });
  };

  useEffect(() => {
    if (location2?.state?.meeting_id) {
      setActiveChat(true);
    }
  }, [location2?.state?.meeting_id]);
  console.log(transcript, "transcript32transcript");

  useEffect(() => {
    if (activeChat && transcript) {
      const id = setInterval(() => {
        chatCreateMonteChatCompletion();
      }, 10000); // 10 seconds interval for API calls

      setIntervalId(id);
      checkNoResponse(); // Start first no-response check

      return () => {
        clearInterval(id);
        setIntervalId(null);
        clearTimeout(timeoutId);
        setTimeoutId(null);
      };
    }
  }, [activeChat, transcript]);

  const generateUuidIfEmpty = () => {
    if (!uuid) {
      // const newUuid = randtoken.generate(16, "abcdefghijklnmopqrstuvwxyz");
      const newUuid = uuidv4();
      setUuid(newUuid);
    }
  };

  const onSubmit = async (data) => {
    if (!uploadImage) {
      pocCreateChatCompletion(data.prompt, uuid);
      setSearchValue("");
    } else {
      let imgUrl = "";
      await uploadData(uploadImage, "/analysis_file")
        .then((newImage) => {
          Swal.close();
          imgUrl = newImage;
        })
        .catch((e) => {
          Swal.close();
        });
      // poccreateChatAnalysisCompletion(imgUrl)
      pocCreateChatCompletion(
        data.prompt,
        uuid,
        `https://msh-dev.s3.amazonaws.com/analysis_file/${imgUrl}`
      );
    }
  };
  const handleAudioEnd = () => {
    // console.log('Audio has ended');
    setAudioData((prev) => ({ ...prev, playStatus: false }));
    // Add any additional logic you want to execute when audio ends here
  };

  const stopAudio = () => {
    // console.log('Audio has Stoped');
    setAudioData((prev) => ({ ...prev, playStatus: false }));
    audioRef.current.pause();
    audioRef.current.currentTime = 0; // Resets audio to the start
  };

  const onSubmitBtn = async (data) => {
    try {
      console.log("onSubmitBtn", data);
      setActiveChat(data);
    } catch (e) {
      console.log("error-->", e);
    }
  };

  useEffect(() => {
    let interval;
    console.log("transcript-->", transcript);
    if (transcript) {
      console.log("transcript: ", transcript);
      checkNoResponse();
      setAudible(true);
      setLoadingChat(true);
      const activeUserObj = {
        login_type_role: localStorage.getItem("user_login_type_role"),
        prompt: transcript,
        uuid: uuid,
        isPriestMeeting: userRole == "4" ? 1 : 0,
      };
      console.log("activeUserObj: ", activeUserObj);

      interval = setInterval(() => {
        console.log("activeUserObj: ", activeUserObj);
        starpilotSingleChatStore(activeUserObj)
          .then((response) => {
            response = JSON.parse(response);
            // console.log('response: ', response);
            cancel();
            if (response.code == process.env.REACT_APP_SUCCESS) {
              // console.log("response.data==>", response.data)
              setStoredTranscript(response.data);
            } else {
              Swal.fire({
                position: "top-end",
                icon: "error",
                title: response.message,
                toast: true,
                showConfirmButton: false,
                timer: 2000,
              });
            }
          })
          .catch((error) => {
            resetTranscript();
            console.log("error", error);
          });
      }, 3000);
    }
    return () => clearInterval(interval);
  }, [transcript, resetTranscript]);

  const handleAudio = async () => {
    setAudioStatus(!audioStatus);
    if (!audioStatus) {
      // Unmute and select default audio input
      SpeechRecognition.startListening({ continuous: true, timeout: 5000 });
    } else {
      SpeechRecognition.stopListening();
    }
  };

  const onImageChange = (event) => {
    if (event.target.files && event.target.files[0]) {
      console.log("event.target.files[0]==>", event.target.files[0]);
      const allowedTypes = [
        "image/jpeg",
        "image/jpg",
        "image/png",
        "application/pdf",
        "text/plain",
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      ];
      if (allowedTypes.includes(event.target.files[0].type)) {
        const fileSizeLimit = 10 * 1024 * 1024;
        if (event.target.files[0].size > fileSizeLimit) {
          Swal.fire({
            position: "top-end",
            icon: "error",
            title: "File size exceeds the limit of 10 MB",
            toast: true,
            showConfirmButton: false,
            timer: 3000,
          });
        } else {
          setImage(URL.createObjectURL(event.target.files[0]));
          console.log("event.target.files[0]-->", event.target.files[0]);
          setUploadImage(event.target.files[0]);
          if (event.target.files[0].type == "application/pdf") {
            setFileType("pdf");
          } else if (event.target.files[0].type == "text/plain") {
            setFileType("text");
          } else if (
            event.target.files[0].type ==
            "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
          ) {
            setFileType("doc");
          } else if (
            event.target.files[0].type ==
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
          ) {
            setFileType("xlsx");
          } else {
            setFileType("image");
          }
        }
      } else {
        Swal.fire({
          position: "top-end",
          icon: "error",
          title:
            "Only Image File(png, jpeg, jpg, PDF, Text, docx, xlsx) Type Allowed!",
          toast: true,
          showConfirmButton: false,
          timer: 3000,
        });
      }
    }
  };

  const uploadData = async (file, folder_type) => {
    const S3_BUCKET = process.env.REACT_APP_AWS_S3_NAME;
    const REGION = process.env.REACT_APP_AWS_S3_REGION;

    AWS.config.update({
      accessKeyId: process.env.REACT_APP_AWS_S3_ACCESS_KEY,
      secretAccessKey: process.env.REACT_APP_AWS_S3_SECRET_KEY,
      region: REGION,
    });
    const ext = file.name.split(".").pop();
    const s3 = new AWS.S3({
      params: { Bucket: S3_BUCKET },
      region: REGION,
    });

    try {
      const newFileName = new Date().getTime() + "." + ext;
      const params = {
        Bucket: S3_BUCKET + folder_type,
        Key: newFileName,
        Body: file,
        ACL: "public-read",
      };

      return new Promise((resolve, reject) => {
        s3.putObject(params, (err, data) => {
          console.log("err, data-->", err, data);
          if (err) {
            reject(err);
          } else {
            resolve(newFileName);
          }
        });
      });
    } catch (error) {
      console.error("Error in UploadData:", error);
    }
  };

  const pocCreateChatCompletion = (prompt, uuid, image = "") => {
    Swal.fire({
      title: "Please wait...",
      didOpen: () => {
        Swal.showLoading();
      },
    });
    cancel();
    console.log("image-->", image);
    starpilotSingleChatStoreTextReply({
      prompt: prompt,
      uuid: uuid,
      imgType: fileType,
      imgUrl: image,
      isPriestMeeting: userRole == "4" ? 1 : 0,
      login_type_role: parseInt(localStorage.getItem("user_login_type_role")),
      languageCode: language,
    }).then(async (res) => {
      console.log("response===>", res);
      var response = JSON.parse(res);
      console.log("response= response==>", response);

      if (response.code == process.env.REACT_APP_SUCCESS) {
        setIsNewChat(0);
        if (fileInputRef.current) {
          fileInputRef.current.value = ""; // Clear the input field
        }
        setImage("");
        setUploadImage(null);
        setFileType("");
        setIsNewChat(0);
        setConversation([]);
        setSearchValue("");
        reset();
        resetTranscript();

        const responseData = response.data.response;
        if (response.data.response) {
          let newMsgT = await constantFunc.convertMarkdownLinksToHTML(
            response.data.response
          );
          console.log(
            newMsgT,
            "responsecChatHistory",
            response.data.chatHistory
          );

          if (userRole === "4" || params?.isPriestMeeting == "true") {
            const firstResponse = response.data.response;
            let translatedMsg = response.data.translatedMsg;

            setSpeakingText(firstResponse);
            setTranslatedText(translatedMsg);
          }
          if (
            response?.data?.chatHistory &&
            response?.data?.chatHistory.length > 0
          ) {
            setConversation(response.data.chatHistory);
          } else {
            setConversation(newMsgT);
          }
        }
      } else {
        Swal.fire({
          position: "top-end",
          icon: "error",
          title: response.message,
          toast: true,
          showConfirmButton: false,
          timer: 2000,
        });
      }
      Swal.close();
    });
  };

  const autoPresc = async (type) => {
    try {
      const meetingDataObj = {
        uuid: uuid,
        from: "singleUser",
        prescriptionType: type,
      };
      setActiveChat(false);
      const serializedObject = queryString.stringify(meetingDataObj);
      let url;
      if (userRole == "4") {
        url = `/priest/auto-prescription-starpilot?${serializedObject}`;
        cancel();
      } else {
        url = `/doctor/auto-prescription-starpilot?${serializedObject}`;
      }
      setTimeout(() => {
        window.open(url, "_blank");
      }, 500);
    } catch (error) {}
  };

  const pocCreateTextToSpeechCompletion = (msg) => {
    if (audioData?.text && audioData?.text == msg) {
      setAudioData((prev) => ({ ...prev, playStatus: true }));
      audioRef.current.src = audioData?.url;
      audioRef.current.controls = true;
      audioRef.current.play();
    } else {
      Swal.fire({
        title: "Please wait...",
        didOpen: () => {
          Swal.showLoading();
        },
      });
      createTextToSpeechCompletion({ text: msg }).then((res) => {
        // console.log('response===>', res)
        var response = JSON.parse(res);
        if (response.code == process.env.REACT_APP_SUCCESS) {
          const arrayBuffer = response.data.buffer.data;
          console.log("arrayBuffer==>", arrayBuffer);
          // Convert buffer data to Blob
          const byteArray = new Uint8Array(arrayBuffer);
          const blob = new Blob([byteArray], { type: "audio/mpeg" });
          // const blob = new Blob([arrayBuffer], { type: 'audio/mp3' });
          const url = URL.createObjectURL(blob);
          // setAudioSrc(url)
          // const audio = new Audio(url);
          console.log("url==>", url);
          if (audioRef.current) {
            console.log("test");
            audioRef.current.src = url;
            audioRef.current.controls = true;
            audioRef.current.play();
            setAudioData({
              url: url,
              text: msg,
              playStatus: true,
            });
            Swal.close();
          } else {
            // console.log("testfsed")
          }
        } else {
          Swal.fire({
            position: "top-end",
            icon: "error",
            title: response.message,
            toast: true,
            showConfirmButton: false,
            timer: 2000,
          });
        }
        if (!handleSweetAlert) {
          Swal.close();
        }
      });
    }
  };

  const closeListeningModal = () => {
    SpeechRecognition.stopListening();
    resetTranscript();
    setStartStopListening(true);
    setListeningModal(false);
    setValue("prompt", searchValue, { shouldValidate: false });
  };

  const handleListening = () => {
    if (handleStartStopListening) {
      SpeechRecognition.startListening({ continuous: true, timeout: 5000 });
      setStartStopListening(false);
    } else {
      // SpeechRecognition.stopListening();
      // resetTranscript()
      // setStartStopListening(true)
      closeListeningModal();
    }
  };

  const emptyImage = async () => {
    try {
      if (fileInputRef.current) {
        fileInputRef.current.value = ""; // Clear the input field
      }
      setImage("");
      setUploadImage(null);
      setFileType("");
    } catch (error) {}
  };

  const handleLeave = async () => {
    try {
      const result = await Swal.fire({
        icon: "warning",
        title: "Exit Meeting",
        text: "Are you sure you want to exit the meeting?",
        showDenyButton: true,
        showCancelButton: true,
        confirmButtonText: "Yes",
        denyButtonText: `${
          userRole === "4" ? "Pastoral Summary" : "Auto Prescription"
        } `,
        customClass: {
          actions: "my-actions",
          cancelButton: "order-1 right-gap",
          confirmButton: "order-2",
          denyButton: "order-3",
        },
      });

      // ✅ Case 1: User confirms exit
      if (result.isConfirmed) {
        await exitMeeting();
        return;
      }

      // ✅ Case 2: User selects Auto Prescription
      if (result.isDenied) {
        const res = await Swal.fire({
          title: `Do you want to continue with ${
            userRole === "4" ? "Pastoral Summary?" : "Auto Prescription?"
          }`,

          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Yes",
        });

        if (res.isConfirmed) {
          const meetingDataObj = {
            uuid,
            from: "singleUser",
            prescriptionType: "final_pres",
          };

          setActiveChat(false);
          const serializedObject = queryString.stringify(meetingDataObj);
          const url =
            userRole === "4"
              ? `/priest/auto-prescription-starpilot?${serializedObject}`
              : `/doctor/auto-prescription-starpilot?${serializedObject}`;

          setTimeout(async () => {
            window.open(url, "_blank");
            await exitMeeting(false);
          }, 500);
        } else {
          // await exitMeeting();
        }
      }

      // ✅ Case 3: User cancels → do nothing
    } catch (error) {
      console.error("Error while leaving meeting:", error);
    }
  };
  let getFinalPostralSummart = async () => {
    await getFinalPostralSummary({
      meeting_id: uuid,
    });
  };
  // ✅ helper function to reduce repetition
  const exitMeeting = async (shouldNavigate = true) => {
    await meetingManager.leave();
    SpeechRecognition.stopListening();
    if (userRole === "4") {
      getFinalPostralSummart();
      cancel();
    }
    localStorage.removeItem("meeting_room");
    if (shouldNavigate) navigate("/");
  };

  useEffect(() => {
    localStorage.setItem("meeting_room", "/doctor/starpilot");
  }, []);

  const silenceTimer = useRef(null);
  let { countdown, setShowPopup, showPopup, startSilenceDetection } =
    useInaudiblePopup({
      audioStatus,
      activeChat,
      loadingChat,
      silenceTimer,
      transcript,
    });

  return (
    <>
      <Header />
      {showPopup && (
        <LatencyModal
          show={showPopup}
          onHide={setShowPopup}
          countdown={countdown}
        />
      )}
      <section className="search-sec py-4">
        <form
          className="form-horizontal m-t-30"
          onSubmit={handleSubmit(onSubmit)}
        >
          <div className="container">
            <div
              className="border bg-white"
              style={{
                borderTopLeftRadius: 20,
                borderTopRightRadius: 20,
                borderBottomRightRadius: 8,
                borderBottomLeftRadius: 8,
              }}
            >
              <div
                className="top position-relative d-flex align-items-center justify-content-center p-3 "
                style={{
                  background: "rgb(33, 111, 200)",
                  borderTopLeftRadius: 20,
                  borderTopRightRadius: 20,
                }}
              >
                <LabelTag
                  className="position-absolute fw-bold px-3 text-white py-1 "
                  style={{
                    background: "#ff8115",
                    borderTopLeftRadius: "5px",
                    borderBottomLeftRadius: "5px",
                  }}
                >
                  Single
                </LabelTag>
                <div
                  className="flex-shrink-0 imgWrp me-3 d-flex align-items-center p-3                                       justify-content-center bg-white rounded-circle"
                  style={{ height: 100, width: 100 }}
                >
                  <img
                    src={talkto}
                    alt=""
                    className="img-fluid rounded object-fit-contain h-100"
                  />
                </div>
                <div
                  className="content text-center"
                  style={{ fontFamily: "Aharoni" }}
                >
                  <h2
                    className="m-0 fw-bold text-white"
                    style={{ fontSize: 50, lineHeight: "40px" }}
                  >
                    {"Starpilot"}
                  </h2>
                  <h5 className="m-0 text-white mt-1">Concierge</h5>
                </div>
              </div>
              <Row>
                <Col lg="12" className="">
                  <div className="">
                    <div className="form-horizontal bg-light py-2 position-relative">
                      {loadingChat && (
                        <div className="position-absolute top-50 ms-4 start-0 translate-middle-y">
                          <span className="fw-bold me-2  themeClr ">
                            SP Responding
                          </span>
                          <img
                            src={chatLoader}
                            alt="Loading..."
                            className="img-fluid "
                            style={{ height: 20 }}
                          />
                        </div>
                      )}
                      <div
                        className="container py-3 border rounded-3"
                        style={{ maxWidth: 600 }}
                      >
                        <div className="d-flex gap-2">
                          <MainBtnWrpper className="d-flex align-items-center justify-content-between w-100 ">
                            <div
                              className="d-flex gap-2 status"
                              style={{ alignItems: "center" }}
                            >
                              <label
                                htmlFor="custom-switch"
                                className="d-block mb-0 p-0 nav-link active"
                              >
                                Status
                              </label>
                              <Form.Check // prettier-ignore
                                type="switch"
                                id="custom-switch"
                                onChange={(x) => onSubmitBtn(x.target.checked)}
                                checked={activeChat}
                              />
                            </div>
                            <div
                              className="right d-flex align-items-center gap-10 meeting-widgets"
                              style={{ flex: "unset" }}
                            >
                              <div
                                className="mute-widget"
                                style={{ background: "#216fc8" }}
                              >
                                <i
                                  onClick={handleAudio}
                                  className={
                                    audioStatus
                                      ? "fa-solid fa-microphone"
                                      : "fa-solid fa-microphone-slash"
                                  }
                                />
                              </div>

                              <AutoPrescriptionPopup
                                btnClass="mute-widget"
                                instruction={instruction}
                                onConfirm={autoPresc}
                              />

                              {/* </OverlayTrigger> */}

                              <button
                                className={
                                  true ? "leave-btn" : "leave-btn-disable"
                                }
                                onClick={handleLeave}
                              >
                                Leave
                              </button>
                            </div>
                          </MainBtnWrpper>
                        </div>
                        {/* {(userRole === "4" ||
                          params?.isPriestMeeting == "true") && (
                          <>
                            <label
                              htmlFor=""
                              className="form-label m-0 fw-bold"
                            >
                              Select Language:
                            </label>
                            <Form.Select
                              className="meeting-status  status-ongoing text-white text-start border-white font_16"
                              aria-label="Default select example "
                              onChange={(e) =>
                                selectLangFunc(e.target.value, "patient")
                              }
                            >
                              {constant?.languageMap.map((item) => (
                                <option value={item.code}>{item?.name}</option>
                              ))}
                            </Form.Select>
                          </>
                        )} */}
                      </div>
                    </div>
                  </div>
                  <div className=" form-horizontal bg-white  position-relative py-4 px-3">
                    <div className="d-flex justify-content-center align-items-center gap-2">
                      <div
                        className="position-relative p-3 rounded w-100"
                        style={{ border: "2px dashed #9d9d9d", maxWidth: 400 }}
                      >
                        {image && (
                          <Button
                            onClick={emptyImage}
                            className="border-0 position-absolute text-white  rounded-circle p-2 d-flex align-items-center justify-content-center"
                            style={{
                              top: 0,
                              right: 0,
                              zIndex: 999,
                              transform: "translateY(-50%)",
                              background: "#216fc8",
                              height: 30,
                              width: 30,
                            }}
                            variant="transparent"
                          >
                            X
                          </Button>
                        )}
                        <input
                          type="file"
                          ref={fileInputRef}
                          onChange={onImageChange}
                          style={{ left: 0, top: 0, zIndex: 99, opacity: 0 }}
                          className="position-absolute h-100 w-100 file"
                        />
                        <div className="text-center">
                          {image && (
                            <img
                              src={
                                (fileType == "pdf" && pdficon) ||
                                (fileType == "text" && txtIcon) ||
                                (fileType == "doc" && docIcon) ||
                                (fileType == "xlsx" && xlsxIcon) ||
                                image
                              }
                              alt=""
                              className="img-fluid mx-auto object-fit-contain"
                              style={{ height: 100, width: 100 }}
                            />
                          )}
                          <p className="m-0 text-muted">Upload File</p>
                          <p
                            className="m-0 text-muted"
                            style={{ fontSize: 10 }}
                          >
                            Upload File for Analysis
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="d-flex gap-2 bg-white px-3 pb-3">
                    <div className="input-group rounded-0">
                      <span className="input-group-text" id="basic-addon1">
                        <i className="fa-solid fa-magnifying-glass"> </i>
                      </span>
                      <input
                        type="text"
                        {...register("prompt")}
                        className="form-control"
                        id="prompt"
                        value={searchValue}
                        placeholder={
                          parseInt(location.poc_type) == 7
                            ? "Hello I have a fever and a headache and some fatigue. What might be the problem? what do you need for accurate differential diagnosis?"
                            : parseInt(location.poc_type) == 2
                            ? "Please check the following prescription for interactions and indications. Please revise the prescription to remove interactions and ameliorate severe indications."
                            : " Send your message..."
                        }
                        onChange={(e) => {
                          setSearchValue(e.target.value);
                        }}
                      />
                      <div className="invalid-feedback">
                        {errors.prompt?.message}
                      </div>
                      {activeChat && !audible && (
                        <>
                          <div className="invalid-feedback">
                            {
                              "I can't hear you, please say something or ask for help"
                            }
                          </div>
                        </>
                      )}
                    </div>
                    <div className="d-flex gap-2">
                      <button className="search-btn" type="submit">
                        <img
                          src={
                            process.env.PUBLIC_URL +
                            "/assets/images/icon/send1.svg"
                          }
                          alt="search"
                        />
                      </button>
                    </div>
                  </div>
                  <div className="py-2">
                    <ul
                      className="list-unstyled px-3 mb-0 d-flex align-items-center gap-3 overflow-auto"
                      style={{ fontSize: 12 }}
                    >
                      {items.map((text, index) => (
                        <motion.li
                          key={index}
                          className="p-1 flex-shrink-0"
                          initial="hidden"
                          animate="visible"
                          exit="exit"
                          custom={index}
                          variants={listVariants}
                        >
                          <div
                            className=" d-inline-flex h-auto pb-2 pt-3 px-3 rounded-4 shadow commonBtn position-relative"
                            style={{ width: 200 }}
                          >
                            <button
                              onClick={() => removeBubble(index)}
                              type="button"
                              className="border-0 position-absolute p-0 text-white bg-transparent"
                              style={{ fontSize: 10, top: 5, right: 5 }}
                            >
                              X
                            </button>
                            {text}
                          </div>
                        </motion.li>
                      ))}
                    </ul>
                  </div>
                  {hints?.length > 0 && (
                    <div className=" overflow-auto d-flex align-items-center justify-content-cednter mb-2 gap-10 px-4 w-100">
                      {hints?.length > 0 &&
                        hints?.map((itm) => (
                          <OverlayTrigger
                            placement="top"
                            delay={{ show: 250, hide: 400 }}
                            overlay={
                              <Tooltip id="button-tooltip">{itm}</Tooltip>
                            }
                          >
                            <div
                              onClick={() => {
                                setSearchValue(itm);
                                setValue("prompt", itm);
                              }}
                              className="d-block py-2 align-items-center justify-content-center btn commonBtn text-truncate px-3 rounded-pill"
                              style={{
                                maxWidth: 300,
                                fontSize: 12,
                                flexShrink: 0,
                              }}
                            >
                              {itm}{" "}
                            </div>
                          </OverlayTrigger>
                        ))}
                    </div>
                  )}
                  <div className="ans-block border-0">
                    {conversation?.map((entry, index) => (
                      <div key={index}>
                        <div className="ans-sub-block border-0">
                          <div className="bg-[#040404] rounded-lg  mb-2 overflow-auto subblock">
                            <div className="aiicon">
                              <img
                                src={
                                  process.env.PUBLIC_URL +
                                  "/assets/images/logo.png"
                                }
                                alt="profile"
                                className="profile"
                              />
                            </div>
                            <div>
                              <p className="mb-2 font_16 text-blue font_600">
                                Monte Sereno (
                                {new Date(entry?.createdAt).toUTCString()})
                              </p>
                              {/* {(userRole === "4" ||
                                (params?.isPriestMeeting == "true" &&
                                  speakingText == entry?.response)) && (
                                <TextReader
                                  index={index}
                                  text={parse(translatedText)}
                                  speak={speak}
                                  cancel={cancel}
                                  speaking={speaking}
                                  supported={supported}
                                  voices={voices}
                                  speakingText={speakingText}
                                  setSpeakingText={setSpeakingText}
                                />
                              )} */}

                              <pre className="mb-2 text-justify white-space-pre">
                                {parse(entry?.response)}
                              </pre>
                              <>
                                <p className="mb-2   font_16 text-blue font_600">
                                  {entry?.prompt?.role} (
                                  {new Date(entry?.createdAt).toUTCString()})
                                </p>
                                <pre className="mb-2   white-space-pre">
                                  {parse(entry.prompt?.transcript)}
                                </pre>
                              </>

                              {(audioData?.playStatus &&
                                audioData?.text == parse(entry?.response) && (
                                  <button
                                    className="search-btn"
                                    type="button"
                                    onClick={() => {
                                      stopAudio();
                                    }}
                                  >
                                    <i className="fa-solid fa-pause text-white" />
                                  </button>
                                )) || (
                                <button
                                  className="search-btn"
                                  type="button"
                                  onClick={() => {
                                    pocCreateTextToSpeechCompletion(
                                      parse(entry?.response)
                                    );
                                  }}
                                >
                                  <i className="fa-solid fa-volume-up text-white" />
                                </button>
                              )}
                              <audio
                                onEnded={handleAudioEnd}
                                style={{ height: 0, width: 0, opacity: 0 }}
                                ref={audioRef}
                                controls
                              >
                                <source src="" type="audio/mpeg" />
                              </audio>
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </Col>
              </Row>
            </div>
          </div>
        </form>
      </section>
      <Footer />

      {showListeningModal && (
        <>
          <div
            className={`modal fade ${showListeningModal ? "show" : ""}`}
            id="staticBackdrop1"
            data-bs-backdrop="static"
            data-bs-keyboard="false"
            aria-labelledby="staticBackdropLabel"
            aria-hidden="true"
            tabIndex="-1"
            style={{ display: showListeningModal ? "block" : "none" }}
          >
            <div className="modal-dialog prescription-modal modal-dialog-centered">
              <div className="modal-content">
                <div className="modal-header border-0">
                  <h5 className="modal-title" id="staticBackdropLabel">
                    Listening
                  </h5>
                  <button
                    type="button"
                    className="btn-close"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                    onClick={closeListeningModal}
                  />
                </div>
                <div className="modal-body">
                  <div className="text-center">
                    {!handleStartStopListening ? (
                      <img
                        src={
                          process.env.PUBLIC_URL +
                          "/assets/images/icon/icons8-sound.gif"
                        }
                        alt="search"
                      />
                    ) : (
                      ""
                    )}
                  </div>
                </div>
                <div className="modal-footer">
                  <button
                    type="button"
                    className="btn submit-btn font_18"
                    onClick={handleListening}
                  >
                    {handleStartStopListening ? "Start" : "Stop"}
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div className="modal-backdrop fade show"></div>
        </>
      )}
    </>
  );
}

const LabelTag = styled.div`
  right: 0;
  @media (max-width: 575px) {
    bottom: 0;
  }
`;

const MainBtnWrpper = styled.div``;
